module.exports = __webpack_public_path__ + "static/img/华为 Mate XT非凡大师.e809e301.png";